import React from 'react';
import {createComponents,SLOGAN} from './components.js';
import './op-cards.css';
import './sdk-integration.css';
export const OpCardRuntimeContext=React.createContext(null);
export const {OpCardHub,OpCardOwnedView}=createComponents(React);

export function OpCardHomeEntry(){return <OpCardRuntimeContext.Consumer>{binding=>binding&&binding.readsEnabled===true
 ? <div className="opcards-home-entry"><button type="button" onClick={()=>binding.pendingPacks&&binding.pendingPacks.known&&binding.pendingPacks.pending?binding.openInventory():binding.openHub('permanent')}>
  <span>OP 典藏卡包</span>{binding.pendingPacks&&binding.pendingPacks.known&&binding.pendingPacks.pending&&<span className="opcards-pending-dot" role="img" aria-label="有尚未揭開的卡包"/>}
 </button></div>:null}</OpCardRuntimeContext.Consumer>;}

export function OpCardEntrySlot(){
 return <OpCardRuntimeContext.Consumer>{binding=>binding&&binding.readsEnabled===true
  ? <nav className="opcards-entries opcards-sdk-entries" aria-label="OP 典藏卡包">
    <button type="button" className="opcards-entry opcards-entry-collection" onClick={()=>binding.openHub('collection')}><strong>典藏圖鑑</strong><span>查看卡片與獎勵</span></button>
    <button type="button" className="opcards-entry opcards-entry-red" onClick={()=>binding.openHub('permanent')}>
     <strong>OP 典藏卡包</strong><span>{SLOGAN}</span><small>2／3／5／10 包 · 點擊查看</small>
     {binding.limitedActivity&&<span className="opcards-limited-badge"><b>限時合輯進行中</b><span>剩餘 {binding.limitedActivity.countdown}</span></span>}
    </button>
   </nav>
  : null}</OpCardRuntimeContext.Consumer>;
}
